'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CallNumber = require('./components/CallNumber.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CallNumber).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/call-number/lib/index.js
// module id = 1394
// module chunks = 1